import { createFileRoute, redirect } from '@tanstack/react-router'

import { RootRoute } from '@/pages/auth/route-entries/password-create-new'
import {
  defaultAuthQuery,
  defaultTokenVerificationQuery,
  tokenVerificationSchema,
} from '@/pages/auth/search-schema'

export const Route = createFileRoute('/_auth/login/password-reset/create-new')({
  validateSearch: (search) =>
    tokenVerificationSchema.catch(defaultTokenVerificationQuery).parse(search),
  component: RootRoute,
  loaderDeps: ({ search }) => {
    return { search }
  },
  loader: ({ deps: { search } }) => {
    if (search.uidb64 === '' || search.token === '' || !search.uidb64 || !search.token) {
      throw redirect({
        to: '/login',
        search: defaultAuthQuery,
        replace: true,
      })
    }

    return {
      search,
    }
  },
})
